export const HomeIcon = () => (
    <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 7.94267L12.2454 1.33225C10.9436 0.222583 8.83305 0.222583 7.53131 1.33225L0 7.75228V21.5H7.77778V15.817C7.77778 14.7708 8.7727 13.9227 10 13.9227C11.2273 13.9227 12.2222 14.7708 12.2222 15.817V21.5H20V7.94267ZM9.10265 2.67174L2.22222 8.53693V19.6057H5.55556V15.817C5.55556 13.7246 7.5454 12.0284 10 12.0284C12.4546 12.0284 14.4444 13.7246 14.4444 15.817V19.6057H17.7778V8.72732L10.674 2.67174C10.2401 2.30185 9.53657 2.30185 9.10265 2.67174Z"
            fill="#363746"
        />
    </svg>
);

export const TaskExecutorsIcon = () => (
    <svg
        width="20"
        height="22"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.0333 12.8284L6.44751 14.2426L10.6902 9.99997L6.44751 5.75733L5.0333 7.17155L7.86172 9.99997L5.0333 12.8284Z"
            fill="#363746"
        />
        <path d="M15 12H11V14H15V12Z" fill="#363746" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H22C23.1046 20 24 19.1046 24 18V2C24 0.895431 23.1046 0 22 0H2ZM22 2H2L2 18H22V2Z"
            fill="#363746"
        />
    </svg>
);

export const WorkflowsIcon = () => (
    <svg
        width="20"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 0H22V8H14V5H12V19H8V22H0V14H8V17H10V5H8V8H0V0H8V3H14V0ZM2 2H6V6H2V2ZM6 16H2V20H6V16Z"
            fill="#363746"
        />
    </svg>
);

export const SettingsIcon = () => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.63635 1C8.63635 0.447715 9.08406 0 9.63635 0H12.3637C12.9159 0 13.3637 0.447715 13.3637 1V2.59685C14.0356 2.78551 14.6746 3.05249 15.2701 3.38716L16.3998 2.25758C16.7903 1.86706 17.4234 1.86707 17.814 2.25759L19.7424 4.18604C20.1329 4.57656 20.1329 5.20972 19.7424 5.60025L18.6128 6.72985C18.9475 7.32539 19.2145 7.96441 19.4032 8.63635H21C21.5523 8.63635 22 9.08406 22 9.63635V12.3637C22 12.9159 21.5523 13.3637 21 13.3637H19.4032C19.2145 14.0356 18.9475 14.6746 18.6128 15.2701L19.7424 16.3998C20.1329 16.7903 20.1329 17.4234 19.7424 17.814L17.814 19.7424C17.4234 20.1329 16.7903 20.1329 16.3998 19.7424L15.2701 18.6128C14.6746 18.9475 14.0356 19.2145 13.3637 19.4032V21C13.3637 21.5523 12.9159 22 12.3637 22H9.63635C9.08406 22 8.63635 21.5523 8.63635 21V19.4032C7.96441 19.2145 7.32539 18.9475 6.72985 18.6128L5.60025 19.7424C5.20972 20.1329 4.57656 20.1329 4.18604 19.7424L2.25759 17.814C1.86707 17.4234 1.86706 16.7903 2.25758 16.3998L3.38716 15.2701C3.05249 14.6746 2.78551 14.0356 2.59685 13.3637H1C0.447715 13.3637 0 12.9159 0 12.3637V9.63635C0 9.08406 0.447715 8.63635 1 8.63635H2.59685C2.78551 7.96441 3.05249 7.32539 3.38716 6.72986L2.25758 5.60025C1.86706 5.20972 1.86707 4.57656 2.25759 4.18604L4.18604 2.25759C4.57656 1.86707 5.20972 1.86706 5.60025 2.25758L6.72986 3.38716C7.32539 3.05249 7.96441 2.78551 8.63635 2.59685V1ZM10.6363 2V3.39266C10.6363 3.87733 10.2888 4.29222 9.81164 4.37718C8.83891 4.55038 7.93825 4.93287 7.15745 5.47729C6.75999 5.75442 6.22103 5.70673 5.8784 5.36412L4.89316 4.3789L4.3789 4.89316L5.36412 5.8784C5.70673 6.22103 5.75442 6.75999 5.47729 7.15745C4.93287 7.93825 4.55038 8.83891 4.37718 9.81164C4.29222 10.2888 3.87733 10.6363 3.39266 10.6363H2V11.3637H3.39266C3.87733 11.3637 4.29222 11.7112 4.37718 12.1884C4.55038 13.1611 4.93287 14.0617 5.47729 14.8425C5.75442 15.24 5.70673 15.779 5.36412 16.1216L4.3789 17.1068L4.89316 17.6211L5.8784 16.6359C6.22103 16.2933 6.75999 16.2456 7.15745 16.5227C7.93825 17.0671 8.83891 17.4496 9.81165 17.6228C10.2888 17.7078 10.6363 18.1227 10.6363 18.6073V20H11.3637V18.6073C11.3637 18.1227 11.7112 17.7078 12.1884 17.6228C13.1611 17.4496 14.0617 17.0671 14.8425 16.5227C15.24 16.2456 15.779 16.2933 16.1216 16.6359L17.1068 17.6211L17.6211 17.1068L16.6359 16.1216C16.2933 15.779 16.2456 15.24 16.5227 14.8425C17.0671 14.0617 17.4496 13.1611 17.6228 12.1884C17.7078 11.7112 18.1227 11.3637 18.6073 11.3637H20V10.6363H18.6073C18.1227 10.6363 17.7078 10.2888 17.6228 9.81165C17.4496 8.83891 17.0671 7.93825 16.5227 7.15745C16.2456 6.75999 16.2933 6.22103 16.6359 5.8784L17.6211 4.89316L17.1068 4.3789L16.1216 5.36412C15.779 5.70673 15.24 5.75442 14.8425 5.47729C14.0617 4.93287 13.1611 4.55038 12.1884 4.37718C11.7112 4.29222 11.3637 3.87733 11.3637 3.39266V2H10.6363ZM7.5 11C7.5 9.06702 9.06702 7.5 11 7.5C12.933 7.5 14.5 9.06702 14.5 11C14.5 12.933 12.933 14.5 11 14.5C9.06702 14.5 7.5 12.933 7.5 11ZM11 9.5C10.1716 9.5 9.5 10.1716 9.5 11C9.5 11.8284 10.1716 12.5 11 12.5C11.8284 12.5 12.5 11.8284 12.5 11C12.5 10.1716 11.8284 9.5 11 9.5Z"
            fill="#363746"
        />
    </svg>
);

export const UsersIcon = () => (
    <svg
        width="24"
        height="20"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 17C0 14.2386 2.23858 12 5 12H13C15.7614 12 18 14.2386 18 17V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V17C16 15.3431 14.6569 14 13 14H5C3.34315 14 2 15.3431 2 17V19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19V17Z"
            fill="#363746"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5C4 2.23858 6.23858 0 9 0C11.7614 0 14 2.23858 14 5C14 7.76142 11.7614 10 9 10C6.23858 10 4 7.76142 4 5ZM9 2C7.34315 2 6 3.34315 6 5C6 6.65685 7.34315 8 9 8C10.6569 8 12 6.65685 12 5C12 3.34315 10.6569 2 9 2Z"
            fill="#363746"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0318 12.88C19.1698 12.3453 19.7153 12.0237 20.25 12.1618C22.4562 12.7314 23.9983 14.7207 24 16.9993V19C24 19.5523 23.5523 20 23 20C22.4477 20 22 19.5523 22 19V17.0007C21.9988 15.6337 21.0737 14.44 19.75 14.0982C19.2153 13.9602 18.8937 13.4147 19.0318 12.88Z"
            fill="#363746"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0312 0.881961C15.1682 0.346935 15.713 0.0242618 16.248 0.16125C18.4604 0.727712 20.0078 2.72124 20.0078 5.005C20.0078 7.28876 18.4604 9.28229 16.248 9.84875C15.713 9.98574 15.1682 9.66306 15.0312 9.12804C14.8943 8.59301 15.2169 8.04824 15.752 7.91125C17.0794 7.57137 18.0078 6.37526 18.0078 5.005C18.0078 3.63474 17.0794 2.43863 15.752 2.09875C15.2169 1.96176 14.8943 1.41699 15.0312 0.881961Z"
            fill="#363746"
        />
    </svg>
);
